module.exports = __webpack_public_path__ + "img/icon_img3.fbde9d86.png";